import {Box, Center, Heading, Image, Stack, Text, useBreakpointValue} from '@chakra-ui/react';
import React from 'react';
import bull from 'assets/images/whiteBull.png'
import darkbg from 'assets/images/OX Guest bg dark.png'
import sgBg from 'assets/images/SGRegisterBg.jpg'
import bullTrans from 'assets/images/bullTrans.png';
import trust from 'assets/images/Trustpilot Micro.svg'
import trustWhite from 'assets/images/TrustpilotMicroWhite.svg'
import { useTranslation } from 'react-i18next';

const GuestBanner = (props) => {
    const { isSGUser } = props
    const {t} = useTranslation('app')
    return <Box
            bg="#003566"
            flex={1}
            h="100vh"
            backgroundImage={isSGUser ? sgBg : darkbg}
            backgroundPosition={isSGUser ? '0 -40px' : 'bottom right'}
            backgroundRepeat={'no-repeat'}
            backgroundSize={isSGUser? '100%': 'contain'}
        >
            <Box
                flex={1}
                h="100vh"
                backgroundImage={isSGUser ? '' : bullTrans}
                backgroundPosition={'bottom right'}
                backgroundRepeat={'no-repeat'}
                backgroundSize={'70%'}
                py={24}
                px={16}
            >
                <Stack spacing={4} sx={isSGUser ?{ justifyContent: 'center', alignItems: 'center' }: {}}>
                    {
                        isSGUser ? 
                            <Stack>
                                <Heading color={'white'} fontSize={'80px'} textAlign={'center'} fontWeight={'700'}>
                                    {t('Trusted')}
                                </Heading>
                                <Heading w={'100%'} color={'white'} fontSize={'80px'} fontWeight={'700'}>
                                    {t('byOurClients')}
                                </Heading>
                            </Stack>
                            : <Heading w={'70%'} color={'white'} fontSize={'100px'} fontWeight={'800'}>
                                {t('trustByOurClients')}
                            </Heading>
                    }
                    
                    <Image src={trustWhite} width={'450px'}/>
                </Stack>
            </Box>
        </Box>
};

export default GuestBanner;
